import React, { useEffect, useState } from "react";
// import objectPath from "object-path";
import ApexCharts from "apexcharts";
// import {useHtmlClassService} from "../../../../_metronic/layout";
import {KTUtil} from '../../../../_metronic/_assets/js/components/util';

const currentYr = new Date().getFullYear();
const numberFormatter = new Intl.NumberFormat();

export function ReceiptsPerMonth({ className, data }) {
  
  // const uiService = useHtmlClassService();

  // const layoutProps = useMemo(() => {
    
  //   return {
  //     colorsGrayGray100: objectPath.get(uiService.config, "js.colors.gray.gray100"),
  //     colorsGrayGray700: objectPath.get(uiService.config, "js.colors.gray.gray700"),
  //     colorsThemeBaseSuccess: objectPath.get(
  //         uiService.config,
  //         "js.colors.theme.base.success"
  //     ),
  //     colorsThemeLightSuccess: objectPath.get(
  //         uiService.config,
  //         "js.colors.theme.light.success"
  //     ),
  //     fontFamily: objectPath.get(uiService.config, "js.fontFamily")
  //   };
  // }, [uiService]);

  const [totalReceipts, setTotalReceipts] = useState(0);

  useEffect(() => {
    if(Array.isArray(data) && data.length === 0){
      return;
    }
    
    const receiptChart = document.getElementById("month_per_month_dashboard");
    const year = new Date().getFullYear();
    
    let receiptData = data.filter( rec => rec.year === `${year}`);

    receiptData = receiptData.sort((a, b) => {
      return a.month_digit - b.month_digit;
    });

    let months = [];
    
    receiptData.forEach(rec => {
      if(!(months.some(m => m === rec.month_name.substring(0, 3)))){
        months.push(rec.month_name.substring(0, 3));
      }
    });
    
    let used = receiptData.filter( rec => rec.status === "Used").map(rec => rec.transactions);

    let issued =  receiptData.filter( rec => rec.status === "Issued").map(rec => rec.transactions);
    
    let refund =  receiptData.filter( rec => rec.status === "Refund In Progress").map(rec => rec.transactions);

    let refundComplete =  receiptData.filter( rec => rec.status === "Refund Completed").map(rec => rec.transactions);

    let totalRcpts = 0;

    if(issued.length > 0){
      totalRcpts = totalRcpts + issued.reduce((a, b) => (a + b));
    }
    if(used.length > 0){
      totalRcpts = totalRcpts + used.reduce((a, b) => (a + b));
    }
    if(refund.length > 0){
      totalRcpts = totalRcpts + refund.reduce((a, b) => (a + b));
    }
    if(refundComplete.length > 0){
      totalRcpts = totalRcpts + refundComplete.reduce((a, b) => (a + b));
    }
    setTotalReceipts(numberFormatter.format(totalRcpts));

    const height = parseInt(KTUtil.css(receiptChart, 'height'));
    const options = getChartOptions(height, months, issued, used, refund, refundComplete);

    const chart = new ApexCharts(receiptChart, options);
    chart.render();

    return function cleanUp() {
      chart.destroy();
    };
  }, [data]);

  function getChartOptions(height, months, issued, used, refund, refundComplete) {
    const options = {
      series: [
        {
          name: "Issued",
          data: issued
        },
        {
          name: "Used",
          data: used
        },
        {
          name: "Refund",
          data: refund
        },
        {
          name: "Refund Completed",
          data: refundComplete
        }
      ],
      chart: {
        height: height,
        type: "bar",
      },
      plotOptions: {
        bar: {
          borderRadius: 10,
          dataLabels: {
            position: "top",
          },
        },
      },
      dataLabels: {
        enabled: false,
        offsetY: -20,
        style: {
          fontSize: "12px",
          colors: ["#304758"],
        },
      },
  
      xaxis: {
        categories: months,
        position: "top",
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        crosshairs: {
          fill: {
            type: "gradient",
            gradient: {
              colorFrom: "#D8E3F0",
              colorTo: "#BED1E6",
              stops: [0, 100],
              opacityFrom: 0.4,
              opacityTo: 0.5,
            },
          },
        },
        tooltip: {
          enabled: true,
        },
      },
      yaxis: {
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        labels: {
          show: false,
        },
      },
      title: {
        text: "Monthly Receipts",
        floating: true,
        offsetY: 330,
        align: "center",
        style: {
          color: "#444",
          fontFamily: `-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif`
        },
      }
    };
    return options;
  };
  

  return (
    <div className={`card card-custom ${className}`}>

      {/* Header */}
      <div className="card-header border-0 pt-5">
        <h3 className="card-title font-weight-bolder ">Receipts Collected Per Month</h3>
        <div className="card-toolbar">

        </div>
      </div>

      {/* Body */}
      <div className="card-body d-flex flex-column">
        <h4>
          { totalReceipts } 
        </h4>
        <span>
          Total Receipts Collected, {currentYr}
        </span>
        <div className="flex-grow-1">
          <div id="month_per_month_dashboard" style={{height: "200px"}}></div>
        </div>
        {/* <div className="pt-5">
          <p className="text-center font-weight-normal font-size-lg pb-7">
            Notes: Current sprint requires stakeholders<br/>
            to approve newly amended policies
          </p>
          <a href="#" className="btn btn-success btn-shadow-hover font-weight-bolder w-100 py-3">Generate Report</a>
        </div> */}
      </div>
    </div>
  );
};